export const ErrorMsg = {
    
    Company : "Please select company",
    Device : "Please select device",    
    InputError : "Form input error. Please correct red column(s) !",
    LoginFail : "Wrong user name or password",

    NeedEmail : "Please fill in User Email",
    NeedFirstName : "Please fill in User FirstName",
    NeedLastName : "Please fill in User LastName",    
    NeedName :  "Please fill in User Name",
    NeedPassword : "Please fill in User Password",

    RepeatName : "This User Name is not available. Please try again.",
    
    SearchNotFound : "Sorry! Ticket Not Found.",
    SelectType : "Please select staff type",
    ServicePeriod : "Please fill in Service period",
    SupportDay : "Please select at least one day",
    SupportTime : "Please fill in support time",
    
    TypeError : "Please fill in valid type name.",    
    UserNotExist : "Wrong user name. User does not exist!"
}